import { auth } from '@/lib/firebase.ts';
import { queryClient } from '@/App.tsx';
import { MyAccessDto } from '@/features/dashboard/_root/types/MyAccessDto.ts';
import { resolveCurrentCompanyId } from '@/features/dashboard/_root/access/currentCompany.ts';
import { userApiQueryKeys } from '@/features/dashboard/_root/api/userApi.queryKeys.ts';

function isLocalUrl(url: string): boolean {
  const baseUrl = import.meta.env.VITE_CAMPDESK_API_URL;
  return url.startsWith(baseUrl) || url.startsWith('/');
}

function resolveUrl(uploadUrl: string): string {
  if (uploadUrl.startsWith('/')) {
    return `${import.meta.env.VITE_CAMPDESK_API_URL}${uploadUrl.slice(1)}`;
  }
  return uploadUrl;
}

async function getAuthHeaders(): Promise<Record<string, string>> {
  await auth.authStateReady();
  const token = await auth?.currentUser?.getIdToken();
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const tenantId = resolveCurrentCompanyId(
    queryClient.getQueryData<MyAccessDto>(userApiQueryKeys.me()),
  );
  if (tenantId) {
    headers['X-Tenant-Id'] = tenantId;
  }
  return headers;
}

export async function uploadToPresignedUrl(
  uploadUrl: string,
  file: File,
  contentType: string,
): Promise<void> {
  const local = isLocalUrl(uploadUrl);
  const url = local ? resolveUrl(uploadUrl) : uploadUrl;

  const headers: Record<string, string> = {
    'Content-Type': contentType,
    ...(local ? await getAuthHeaders() : {}),
  };

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: file,
  });

  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }
}
